<template>
  <div class="border-b border-b-neutral-200 bg-white lg:border-b-0 lg:border-r lg:border-r-neutral-100 lg:shadow-lg lg:shadow-neutral-200 dark:border-b-neutral-700 dark:bg-neutral-950 dark:lg:border-r-neutral-700 dark:lg:shadow-neutral-800">
    <slot />
  </div>
</template>
